import { render, staticRenderFns } from "./FileImporter.vue?vue&type=template&id=3b2947d6&scoped=true&"
import script from "./FileImporter.vue?vue&type=script&lang=js&"
export * from "./FileImporter.vue?vue&type=script&lang=js&"
import style0 from "./FileImporter.vue?vue&type=style&index=0&id=3b2947d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2947d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VCol } from 'vuetify/lib'
import { VDatePicker } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFileInput } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VRow } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VCard,VCardActions,VCardText,VCheckbox,VChip,VCol,VDatePicker,VDialog,VFileInput,VForm,VRow,VSpacer,VTextField})
